export default "__VITE_ASSET__B0j680aN__"